











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {DialogRemove} from '@/helpers/dialog/DialogRemove'
import {TipoPessoaRecebedor} from '@/model/resource/TipoPessoaRecebedor'
import {TipoPessoaRecebedorCollection} from '@/model/collection/TipoPessoaRecebedorCollection'
import {ListTipoPessoaRecebedorSchema} from '@/schema/resource/TipoPessoaRecebedor/ListTipoPessoaRecebedorSchema'
import {CsvTipoPessoaRecebedorSchema} from '@/schema/resource/TipoPessoaRecebedor/CsvTipoPessoaRecebedorSchema'

@Component
export default class ListTipoPessoaRecebedorView extends Mixins(
  MixinQueryRouter
) {
  schema = new ListTipoPessoaRecebedorSchema()
  collection = new TipoPessoaRecebedorCollection()

  async created() {
    this.collection.perPage = 20
    await this.query()
  }

  goToPersistView(item: TipoPessoaRecebedor) {
    Helper.pushByName('editTipoPessoaRecebedor', item.$id)
  }

  async removeItem(item: TipoPessoaRecebedor) {
    await new DialogRemove(item).confirm(() => item.removeTipoPessoaRecebedor())
    await this.collection.listTipoPessoaRecebedor()
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new TipoPessoaRecebedorCollection()
      .clearFilters()
      .addFilter(params)

    await csv.listCsvTipoPessoaRecebedor()
    new CsvTipoPessoaRecebedorSchema().downloadCsv(csv.all())
  }
}
